module.exports = __webpack_public_path__ + "img/343.2747e86c.png";